var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlood(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.952,39.046c-2.863-5.314-6.36-10.523-8.914-14.327l-0.314-0.468c-0.492-0.728-1.239-1.22-2.102-1.386 c-0.863-0.167-1.739,0.015-2.469,0.508c-0.348,0.236-0.643,0.532-0.881,0.884l-0.321,0.478c-2.551,3.8-6.044,9.004-8.903,14.311 c-3.764,6.985-5.517,12.317-5.517,16.78c0,9.577,7.836,17.368,17.469,17.368c9.632,0,17.469-7.791,17.469-17.368 C65.469,51.364,63.716,46.033,59.952,39.046z M48,69.194c-7.427,0-13.469-5.997-13.469-13.368c0-3.774,1.601-8.503,5.038-14.882 c2.668-4.952,5.953-9.881,8.431-13.573c2.479,3.694,5.763,8.621,8.431,13.573c3.438,6.38,5.038,11.109,5.038,14.882 C61.469,63.197,55.427,69.194,48,69.194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.694,64.165c-1.031,0-2.044-0.16-3.014-0.478c-2.529-0.826-4.625-2.677-5.751-5.079 c-0.593-1.266-0.894-2.62-0.894-4.026c0-1.104-0.896-2-2-2s-2,0.896-2,2c0,1.997,0.428,3.923,1.272,5.724 c1.593,3.398,4.557,6.017,8.131,7.185c1.371,0.447,2.803,0.675,4.256,0.675c1.104,0,2-0.896,2-2S50.799,64.165,49.694,64.165z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood);
export default __webpack_public_path__ + "static/media/blood.d1f5b0a888d9d2f9dcdf448482c33c90.svg";
export { ForwardRef as ReactComponent };